import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import Navbar from '../components/common/Navbar';
import '../assets/css/style.css';
import './ModificationForm.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

const CHANGE_TYPES = [
  { value: 'addition', label: 'Addition' },
  { value: 'modification', label: 'Modification' },
];

const HOLDERS = [
  { value: '1st_holder', label: '1st Holder' },
  { value: '2nd_holder', label: '2nd Holder' },
  { value: '3rd_holder', label: '3rd Holder' },
];

const INCOME_RANGES = [
  { value: 'below_1lakh', label: 'Below Rs. 1 lakh' },
  { value: '1_5lakh', label: 'Rs. 1 lakh to Rs. 5 lakhs' },
  { value: '5_10lakh', label: 'Rs. 5 lakhs to Rs. 10 lakhs' },
  { value: '10_25lakh', label: 'Rs. 10 lakhs to Rs. 25 lakhs' },
  { value: 'above_25lakh', label: 'More than Rs. 25 lakhs' },
];

const SECTIONS = [
  { value: 'address', label: 'Address' },
  { value: 'email', label: 'Email' },
  { value: 'mobile', label: 'Mobile' },
  { value: 'income', label: 'Income Details' },
  { value: 'others', label: 'Others' },
];

const NOMINEES = [
  { value: '1st_nominee', label: '1st Nominee' },
  { value: '2nd_nominee', label: '2nd Nominee' },
  { value: '3rd_nominee', label: '3rd Nominee' },
];

function ModificationForm() {
  const { clientId } = useParams();
  const history = useHistory();

  const [activeTab, setActiveTab] = useState('1st_holder');
  const [expandedSection, setExpandedSection] = useState(null);
  const [activeNomineeTab, setActiveNomineeTab] = useState('1st_nominee');
  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  const [formData, setFormData] = useState({
    // Holder PANs and validation
    first_holder_pan: '',
    first_holder_validated: false,
    first_holder_details: {},
    first_holder_name: '',
    second_holder_pan: '',
    second_holder_validated: false,
    second_holder_details: {},
    second_holder_name: '',
    third_holder_pan: '',
    third_holder_validated: false,
    third_holder_details: {},
    third_holder_name: '',
    // 1st Holder
    first_holder_address_change_type: '',
    first_holder_address_existing: '',
    first_holder_address_new: '',
    first_holder_address_from_cm: '',
    first_holder_email_change_type: '',
    first_holder_email_existing: '',
    first_holder_email_new: '',
    first_holder_email_from_cm: '',
    first_holder_mobile_change_type: '',
    first_holder_mobile_existing: '',
    first_holder_mobile_new: '',
    first_holder_mobile_from_cm: '',
    first_holder_signature_file: null,
    first_holder_others_change_type: '',
    first_holder_others_specify: '',
    first_holder_others_existing: '',
    first_holder_others_new: '',
    first_holder_income: '',
    first_holder_add_signature: '',
    // 2nd Holder
    second_holder_address_change_type: '',
    second_holder_address_existing: '',
    second_holder_address_new: '',
    second_holder_address_from_cm: '',
    second_holder_email_change_type: '',
    second_holder_email_existing: '',
    second_holder_email_new: '',
    second_holder_email_from_cm: '',
    second_holder_mobile_change_type: '',
    second_holder_mobile_existing: '',
    second_holder_mobile_new: '',
    second_holder_mobile_from_cm: '',
    second_holder_signature_file: null,
    second_holder_others_change_type: '',
    second_holder_others_specify: '',
    second_holder_others_existing: '',
    second_holder_others_new: '',
    second_holder_income: '',
    second_holder_add_signature: '',
    // 3rd Holder
    third_holder_address_change_type: '',
    third_holder_address_existing: '',
    third_holder_address_new: '',
    third_holder_address_from_cm: '',
    third_holder_email_change_type: '',
    third_holder_email_existing: '',
    third_holder_email_new: '',
    third_holder_email_from_cm: '',
    third_holder_mobile_change_type: '',
    third_holder_mobile_existing: '',
    third_holder_mobile_new: '',
    third_holder_mobile_from_cm: '',
    third_holder_signature_file: null,
    third_holder_others_change_type: '',
    third_holder_others_specify: '',
    third_holder_others_existing: '',
    third_holder_others_new: '',
    third_holder_income: '',
    third_holder_add_signature: '',
    // Nominees
    first_nominee_name: '',
    first_nominee_from_cm: false,
    first_nominee_email_existing: '',
    first_nominee_email: '',
    first_nominee_email_change_type: '',
    first_nominee_mobile_existing: '',
    first_nominee_mobile: '',
    first_nominee_mobile_change_type: '',
    first_nominee_share_percentage: '',
    first_nominee_dob: '',
    first_nominee_guardian_name: '',
    first_nominee_guardian_email: '',
    first_nominee_guardian_mobile: '',
    second_nominee_name: '',
    second_nominee_email_existing: '',
    second_nominee_email: '',
    second_nominee_email_change_type: '',
    second_nominee_mobile_existing: '',
    second_nominee_mobile: '',
    second_nominee_mobile_change_type: '',
    second_nominee_share_percentage: '',
    second_nominee_dob: '',
    second_nominee_guardian_name: '',
    second_nominee_guardian_email: '',
    second_nominee_guardian_mobile: '',
    third_nominee_name: '',
    third_nominee_email_existing: '',
    third_nominee_email: '',
    third_nominee_email_change_type: '',
    third_nominee_mobile_existing: '',
    third_nominee_mobile: '',
    third_nominee_mobile_change_type: '',
    third_nominee_share_percentage: '',
    third_nominee_dob: '',
    third_nominee_guardian_name: '',
    third_nominee_guardian_email: '',
    third_nominee_guardian_mobile: '',
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSearching, setIsSearching] = useState({
    '1st_holder': false,
    '2nd_holder': false,
    '3rd_holder': false,
  });
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    document.title = 'Modification Form - Agreya Capital';
  }, []);

  const convertHolderFormat = (holder) => {
    const mapping = {
      '1st_holder': 'first_holder',
      '2nd_holder': 'second_holder',
      '3rd_holder': 'third_holder',
    };
    return mapping[holder] || holder;
  };

  const convertNomineeFormat = (fieldName) => {
    return fieldName
      .replace('1st_nominee', 'first_nominee')
      .replace('2nd_nominee', 'second_nominee')
      .replace('3rd_nominee', 'third_nominee');
  };

  const tabSequence = ['1st_holder', '2nd_holder', '3rd_holder', 'nominee', 'uploads'];

  const validateCurrentTab = () => {
    const tabErrors = {};
    const currentTab = tabSequence[currentTabIndex];


    // No validation needed for uploads tab
    if (currentTab === 'uploads') {
      return tabErrors;
    }

    if (currentTab === 'nominee') {
      // Validate nominees on nominees tab
      const nominees = [
        { keyPrefix: '1st_nominee', dbPrefix: 'first_nominee', name: '1st Nominee' },
        { keyPrefix: '2nd_nominee', dbPrefix: 'second_nominee', name: '2nd Nominee' },
        { keyPrefix: '3rd_nominee', dbPrefix: 'third_nominee', name: '3rd Nominee' },
      ];

      let activeNominees = 0;
      let totalShare = 0;

      nominees.forEach((nominee) => {
        // Convert to backend format (1st_nominee -> first_nominee)
        const dbPrefix = nominee.dbPrefix;

        // Check if any change type is selected or any data is filled
        const emailChangeType = formData[`${dbPrefix}_email_change_type`];
        const emailValue = formData[`${dbPrefix}_email`];
        const emailExisting = formData[`${dbPrefix}_email_existing`];

        const mobileChangeType = formData[`${dbPrefix}_mobile_change_type`];
        const mobileValue = formData[`${dbPrefix}_mobile`];
        const mobileExisting = formData[`${dbPrefix}_mobile_existing`];

        const share = formData[`${dbPrefix}_share_percentage`];
        const dob = formData[`${dbPrefix}_dob`];
        const guardianName = formData[`${dbPrefix}_guardian_name`];
        const guardianEmail = formData[`${dbPrefix}_guardian_email`];
        const guardianMobile = formData[`${dbPrefix}_guardian_mobile`];

        const hasAnyChange = emailChangeType || emailValue || emailExisting || mobileChangeType || mobileValue || mobileExisting || share || dob || guardianName || guardianEmail || guardianMobile;

        if (!hasAnyChange) return; // Skip if no changes selected

        activeNominees++;
        const name = formData[`${dbPrefix}_name`];

        // If any change is made, name is mandatory
        if (!name) {
          tabErrors[`${dbPrefix}_name`] = `${nominee.name} name is required`;
        } else {
          const nameError = validators.name(name);
          if (nameError) tabErrors[`${dbPrefix}_name`] = nameError;
        }

        // Validate email if email change type is selected
        if (emailChangeType) {
          const email = formData[`${dbPrefix}_email`];
          if (!email) {
            tabErrors[`${dbPrefix}_email`] = `${nominee.name} email is required`;
          } else {
            const emailError = validators.email(email);
            if (emailError) tabErrors[`${dbPrefix}_email`] = emailError;
          }
        }

        // Validate mobile if mobile change type is selected
        if (mobileChangeType) {
          const mobile = formData[`${dbPrefix}_mobile`];
          if (!mobile) {
            tabErrors[`${dbPrefix}_mobile`] = `${nominee.name} mobile is required`;
          } else {
            const mobileError = validators.mobile(mobile);
            if (mobileError) tabErrors[`${dbPrefix}_mobile`] = mobileError;
          }
        }

        // Validate share percentage (always required if any other change is selected)
        if (!share) {
          tabErrors[`${dbPrefix}_share_percentage`] = `${nominee.name} share percentage is required`;
        } else {
          const shareError = validators.sharePercentage(share);
          if (shareError) {
            tabErrors[`${dbPrefix}_share_percentage`] = shareError;
          } else {
            totalShare += parseFloat(share);
          }
        }

        // Validate guardian details if nominee is minor (age < 18)
        if (dob) {
          const dobDate = new Date(dob);
          const today = new Date();
          const age = today.getFullYear() - dobDate.getFullYear() - (today < new Date(today.getFullYear(), dobDate.getMonth(), dobDate.getDate()) ? 1 : 0);

          if (age < 18) {
            const guardianNameValue = formData[`${dbPrefix}_guardian_name`];
            const guardianEmailValue = formData[`${dbPrefix}_guardian_email`];
            const guardianMobileValue = formData[`${dbPrefix}_guardian_mobile`];

            // Guardian name is mandatory for minors
            if (!guardianNameValue) {
              tabErrors[`${dbPrefix}_guardian_name`] = `${nominee.name} guardian name is required (minor)`;
            } else {
              const guardianNameError = validators.name(guardianNameValue);
              if (guardianNameError) tabErrors[`${dbPrefix}_guardian_name`] = guardianNameError;
            }

            // Guardian email is mandatory for minors
            if (!guardianEmailValue) {
              tabErrors[`${dbPrefix}_guardian_email`] = `${nominee.name} guardian email is required (minor)`;
            } else {
              const guardianEmailError = validators.email(guardianEmailValue);
              if (guardianEmailError) tabErrors[`${dbPrefix}_guardian_email`] = guardianEmailError;
            }

            // Guardian mobile is mandatory for minors
            if (!guardianMobileValue) {
              tabErrors[`${dbPrefix}_guardian_mobile`] = `${nominee.name} guardian mobile is required (minor)`;
            } else {
              const guardianMobileError = validators.mobile(guardianMobileValue);
              if (guardianMobileError) tabErrors[`${dbPrefix}_guardian_mobile`] = guardianMobileError;
            }
          }
        }
      });

      if (activeNominees > 0 && Math.abs(totalShare - 100) > 0.01) {
        tabErrors.nominee_share_total = `Total share percentage must equal 100% (currently ${totalShare.toFixed(2)}%)`;
      }
    } else {
      // Validate holder details for 1st, 2nd, 3rd holder tabs
      const holderKey = convertHolderFormat(currentTab);

      ['1st_holder', '2nd_holder', '3rd_holder'].forEach(holder => {
        if (holder !== currentTab) return;

        const key = convertHolderFormat(holder);
        const changeTypes = {
          address: formData[`${key}_address_change_type`],
          email: formData[`${key}_email_change_type`],
          mobile: formData[`${key}_mobile_change_type`],
          others: formData[`${key}_others_change_type`],
        };

        // Check if ANY change is selected for this holder (including income)
        const hasAnyChange = changeTypes.address || changeTypes.email || changeTypes.mobile || changeTypes.others || formData[`${key}_income`];

        // For 2nd and 3rd holders, PAN is mandatory if any changes are entered
        if ((holder === '2nd_holder' || holder === '3rd_holder') && hasAnyChange) {
          const panValue = formData[`${key}_pan`];
          if (!panValue || panValue.trim() === '') {
            tabErrors[`${key}_pan`] = `${holder.replace('_', ' ').toUpperCase()} PAN is required when changes are selected`;
          } else {
            const panError = validators.pan(panValue);
            if (panError) tabErrors[`${key}_pan`] = panError;
          }
        }

        // For 2nd and 3rd holders, validate name if any change is selected (including income)
        if (hasAnyChange && holder !== '1st_holder') {
          const name = formData[`${key}_name`];
          if (!name || name.trim() === '') {
            tabErrors[`${key}_name`] = `${holder.replace('_', ' ').toUpperCase()} name is required when changes are selected`;
          } else {
            const nameError = validators.name(name);
            if (nameError) tabErrors[`${key}_name`] = nameError;
          }
        }

        // Validate address if change type is selected
        if (changeTypes.address) {
          if (!formData[`${key}_address_new`] || formData[`${key}_address_new`].trim() === '') {
            tabErrors[`${key}_address_new`] = `${holder.replace('_', ' ').toUpperCase()} address is required when change type is selected`;
          } else {
            const addressError = validators.address(formData[`${key}_address_new`]);
            if (addressError) tabErrors[`${key}_address_new`] = addressError;
          }
        }

        // Validate email if change type is selected
        if (changeTypes.email) {
          if (!formData[`${key}_email_new`] || formData[`${key}_email_new`].trim() === '') {
            tabErrors[`${key}_email_new`] = `${holder.replace('_', ' ').toUpperCase()} email is required when change type is selected`;
          } else {
            const emailError = validators.email(formData[`${key}_email_new`]);
            if (emailError) tabErrors[`${key}_email_new`] = emailError;
          }
        }

        // Validate mobile if change type is selected
        if (changeTypes.mobile) {
          if (!formData[`${key}_mobile_new`] || formData[`${key}_mobile_new`].trim() === '') {
            tabErrors[`${key}_mobile_new`] = `${holder.replace('_', ' ').toUpperCase()} mobile is required when change type is selected`;
          } else {
            const mobileError = validators.mobile(formData[`${key}_mobile_new`]);
            if (mobileError) tabErrors[`${key}_mobile_new`] = mobileError;
          }
        }

        // Validate others if change type is selected
        if (changeTypes.others) {
          if (!formData[`${key}_others_new`] || formData[`${key}_others_new`].trim() === '') {
            tabErrors[`${key}_others_new`] = `${holder.replace('_', ' ').toUpperCase()} details are required when change type is selected`;
          } else {
            const othersError = validators.address(formData[`${key}_others_new`]);
            if (othersError) tabErrors[`${key}_others_new`] = othersError;
          }
        }
      });
    }

    return tabErrors;
  };

  const handleNextTab = () => {
    if (currentTabIndex < tabSequence.length - 1) {
      // Check if PAN is entered in 1st holder tab (mandatory only for 1st holder)
      const currentTab = tabSequence[currentTabIndex];
      if (currentTab === '1st_holder') {
        const holderKey = convertHolderFormat(currentTab);
        const panField = `${holderKey}_pan`;

        if (!formData[panField]) {
          setErrors({
            validation: 'Please enter PAN for 1ST HOLDER before proceeding'
          });
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
      }

      // For nominee tab, ensure total share equals 100%
      if (currentTab === 'nominee') {
        const first = parseFloat(formData['first_nominee_share_percentage']) || 0;
        const second = parseFloat(formData['second_nominee_share_percentage']) || 0;
        const third = parseFloat(formData['third_nominee_share_percentage']) || 0;
        const total = first + second + third;

        if (total > 0 && Math.abs(total - 100) > 0.01) {
          setErrors({
            nominee_share_total: `Total share must equal 100% (currently ${total.toFixed(2)}%)`
          });
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
      }

      // Validate current tab before moving to next
      const tabErrors = validateCurrentTab();

      if (Object.keys(tabErrors).length > 0) {
        // Show errors and don't proceed
        setErrors({
          ...tabErrors,
          validation: 'Please fix the errors below before continuing'
        });

        // Auto-expand sections that have errors
        const currentTab = tabSequence[currentTabIndex];
        if (currentTab !== 'nominee') {
          const holderKey = convertHolderFormat(currentTab);

          // Find which section has an error
          const sections = ['address', 'email', 'mobile', 'income', 'others'];
          for (let section of sections) {
            const possibleFields = [
              `${holderKey}_${section}_new`,
              `${holderKey}_${section}_change_type`,
              `${holderKey}_${section}`
            ];

            if (possibleFields.some(field => tabErrors[field])) {
              // Expand the section with error
              setExpandedSection(`${currentTab}-${section}`);
              break;
            }
          }
        }

        // Scroll to first error
        setTimeout(() => {
          const firstErrorField = Object.keys(tabErrors)[0];
          const errorElement = document.querySelector(`input[name="${firstErrorField}"], textarea[name="${firstErrorField}"], select[name="${firstErrorField}"]`);
          if (errorElement) {
            errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            errorElement.focus();
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }, 100);
        return;
      }

      // No errors, proceed to next tab
      const nextIndex = currentTabIndex + 1;
      setCurrentTabIndex(nextIndex);
      setActiveTab(tabSequence[nextIndex]);
      setErrors({}); // Clear errors when moving to next tab
      setExpandedSection(null); // Collapse sections when moving to next tab
      window.scrollTo(0, 0);
    }
  };

  const handlePreviousTab = () => {
    if (currentTabIndex > 0) {
      const prevIndex = currentTabIndex - 1;
      setCurrentTabIndex(prevIndex);
      setActiveTab(tabSequence[prevIndex]);
      setErrors({}); // Clear errors when moving to previous tab
      window.scrollTo(0, 0);
    }
  };

  const handleTabClick = (index) => {
    // Prevent switching tabs if 1st holder is not validated (for tabs other than 1st holder)
    if (index > 0 && !formData.first_holder_validated) {
      setErrors({
        validation: 'Please verify 1st holder with a valid individual account before accessing other tabs'
      });
      return; // Prevent tab switch
    }

    // Validate current tab before allowing switch
    if (index !== currentTabIndex) {
      // Check if PAN is entered in 1st holder tab (mandatory only for 1st holder)
      const currentTab = tabSequence[currentTabIndex];
      if (currentTab === '1st_holder') {
        const holderKey = convertHolderFormat(currentTab);
        const panField = `${holderKey}_pan`;

        if (!formData[panField]) {
          setErrors({
            validation: 'Please enter PAN for 1ST HOLDER before proceeding'
          });
          return; // Prevent tab switch
        }
      }

      const tabErrors = validateCurrentTab();

      if (Object.keys(tabErrors).length > 0) {
        // Show errors and don't proceed
        setErrors({
          ...tabErrors,
          validation: 'Please fix the errors below before continuing'
        });
        return; // Prevent tab switch
      }
    }

    // Clear errors on successful tab switch
    setCurrentTabIndex(index);
    setActiveTab(tabSequence[index]);
    setErrors({});
    window.scrollTo(0, 0);
  };

  const handleFormKeyPress = (e) => {
    // Prevent form submission on Enter key
    if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
      e.preventDefault();
    }
  };

  const handleInputChange = (e) => {
    // Extract properties immediately to avoid React event pooling issues
    const name = e.target.name;
    const value = e.target.value;

    setFormData(prev => {
      const updates = {
        ...prev,
        [name]: value
      };

      // Auto-populate existing fields when modification is selected for holders
      if (name.includes('_address_change_type') && value === 'modification') {
        const holderKey = name.replace('_address_change_type', '');
        if (prev[`${holderKey}_address_from_cm`] && !prev[`${holderKey}_address_existing`]) {
          updates[`${holderKey}_address_existing`] = prev[`${holderKey}_address_from_cm`];
        }
      }
      if (name.includes('_email_change_type') && value === 'modification') {
        const holderKey = name.replace('_email_change_type', '');
        if (prev[`${holderKey}_email_from_cm`] && !prev[`${holderKey}_email_existing`]) {
          updates[`${holderKey}_email_existing`] = prev[`${holderKey}_email_from_cm`];
        }
      }
      if (name.includes('_mobile_change_type') && value === 'modification') {
        const holderKey = name.replace('_mobile_change_type', '');
        if (prev[`${holderKey}_mobile_from_cm`] && !prev[`${holderKey}_mobile_existing`]) {
          updates[`${holderKey}_mobile_existing`] = prev[`${holderKey}_mobile_from_cm`];
        }
      }

      return updates;
    });

    // Clear error on change
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
    // Clear nominee share total error when share percentage is edited
    if (name.includes('share_percentage') && errors.nominee_share_total) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.nominee_share_total;
        return newErrors;
      });
    }
  };

  const validateField = (name, value) => {
    let error = null;

    // Only validate if value is not empty
    if (!value || value.toString().trim() === '') {
      // Clear error for empty fields
      if (errors[name]) {
        setErrors(prev => ({
          ...prev,
          [name]: ''
        }));
      }
      return;
    }

    // PAN validation (all holders)
    if (name.includes('pan')) {
      error = validators.pan(value);
    }
    // Email validation (both holder and nominee)
    else if (name.includes('email') && (name.includes('_new') || name.includes('nominee'))) {
      error = validators.email(value);
    }
    // Mobile validation (both holder and nominee)
    else if (name.includes('mobile') && (name.includes('_new') || name.includes('nominee'))) {
      error = validators.mobile(value);
    }
    // Name validation (nominee only)
    else if (name.includes('nominee') && name.includes('name')) {
      error = validators.name(value);
    }
    // Address validation (holder)
    else if (name.includes('address') && name.includes('_new')) {
      error = validators.address(value);
    }
    // Share percentage validation (nominee)
    else if (name.includes('share_percentage')) {
      error = validators.sharePercentage(value);
    }

    // Update errors state
    if (error) {
      setErrors(prev => ({
        ...prev,
        [name]: error
      }));
    } else {
      // Clear error if validation passes
      if (errors[name]) {
        setErrors(prev => ({
          ...prev,
          [name]: ''
        }));
      }
    }
  };

  const handleFieldBlur = (e) => {
    // Extract properties immediately to avoid React event pooling issues
    const name = e.target.name;
    const value = e.target.value;
    // Validate in next tick to avoid stale closure
    setTimeout(() => {
      validateField(name, value);
    }, 0);
  };

  const handleFileChange = (e) => {
    // Extract properties immediately to avoid React event pooling issues
    const name = e.target.name;
    const files = e.target.files;

    if (files && files.length > 0) {
      setFormData(prev => ({
        ...prev,
        [name]: files[0]
      }));
    }
  };

  const clearAllModificationData = () => {
    return {
      // Clear 1st holder modifications
      first_holder_address_change_type: '',
      first_holder_address_existing: '',
      first_holder_address_new: '',
      first_holder_email_change_type: '',
      first_holder_email_existing: '',
      first_holder_email_new: '',
      first_holder_mobile_change_type: '',
      first_holder_mobile_existing: '',
      first_holder_mobile_new: '',
      first_holder_others_change_type: '',
      first_holder_others_specify: '',
      first_holder_others_existing: '',
      first_holder_others_new: '',
      first_holder_income: '',
      first_holder_add_signature: '',
      first_holder_signature_file: null,
      // Clear 2nd holder modifications
      second_holder_address_change_type: '',
      second_holder_address_existing: '',
      second_holder_address_new: '',
      second_holder_email_change_type: '',
      second_holder_email_existing: '',
      second_holder_email_new: '',
      second_holder_mobile_change_type: '',
      second_holder_mobile_existing: '',
      second_holder_mobile_new: '',
      second_holder_others_change_type: '',
      second_holder_others_specify: '',
      second_holder_others_existing: '',
      second_holder_others_new: '',
      second_holder_income: '',
      second_holder_add_signature: '',
      second_holder_signature_file: null,
      // Clear 3rd holder modifications
      third_holder_address_change_type: '',
      third_holder_address_existing: '',
      third_holder_address_new: '',
      third_holder_email_change_type: '',
      third_holder_email_existing: '',
      third_holder_email_new: '',
      third_holder_mobile_change_type: '',
      third_holder_mobile_existing: '',
      third_holder_mobile_new: '',
      third_holder_others_change_type: '',
      third_holder_others_specify: '',
      third_holder_others_existing: '',
      third_holder_others_new: '',
      third_holder_income: '',
      third_holder_add_signature: '',
      third_holder_signature_file: null,
      // Clear all nominee data
      first_nominee_name: '',
      first_nominee_email_existing: '',
      first_nominee_email: '',
      first_nominee_email_change_type: '',
      first_nominee_mobile_existing: '',
      first_nominee_mobile: '',
      first_nominee_mobile_change_type: '',
      first_nominee_share_percentage: '',
      first_nominee_dob: '',
      first_nominee_guardian_name: '',
      first_nominee_guardian_email: '',
      first_nominee_guardian_mobile: '',
      second_nominee_name: '',
      second_nominee_email_existing: '',
      second_nominee_email: '',
      second_nominee_email_change_type: '',
      second_nominee_mobile_existing: '',
      second_nominee_mobile: '',
      second_nominee_mobile_change_type: '',
      second_nominee_share_percentage: '',
      second_nominee_dob: '',
      second_nominee_guardian_name: '',
      second_nominee_guardian_email: '',
      second_nominee_guardian_mobile: '',
      third_nominee_name: '',
      third_nominee_email_existing: '',
      third_nominee_email: '',
      third_nominee_email_change_type: '',
      third_nominee_mobile_existing: '',
      third_nominee_mobile: '',
      third_nominee_mobile_change_type: '',
      third_nominee_share_percentage: '',
      third_nominee_dob: '',
      third_nominee_guardian_name: '',
      third_nominee_guardian_email: '',
      third_nominee_guardian_mobile: '',
    };
  };

  const handleSearchClient = async (holder) => {
    const holderKey = convertHolderFormat(holder);
    const panField = `${holderKey}_pan`;
    const pan = formData[panField];

    if (!pan || pan.trim() === '') {
      setErrors(prev => ({
        ...prev,
        [panField]: 'PAN is required'
      }));
      return;
    }

    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan)) {
      setErrors(prev => ({
        ...prev,
        [panField]: 'PAN format should be like AAAAA0000A'
      }));
      return;
    }

    setIsSearching(prev => ({
      ...prev,
      [holder]: true
    }));

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/modification-form/search-client/`,
        {
          pan: pan.toUpperCase(),
          holder_number: holder.replace('_holder', '')
        }
      );

      if (response.data.success) {
        // Check if client type is individual (only 'individual' accounts allowed)
        const clientType = response.data.type_of_client ? response.data.type_of_client.toLowerCase().trim() : '';
        if (!clientType || clientType !== 'individual') {
          setErrors(prev => ({
            ...prev,
            [panField]: 'If the applicant is a Minor / Non-Individual, please do not proceed further and kindly contact us at ops@agreyacapital.com. Additional information to be separately obtained from NRI applicants.'
          }));
          setFormData(prev => ({
            ...prev,
            [`${holderKey}_validated`]: false,
            [`${holderKey}_details`]: {}
          }));
          return;
        }

        const updates = {
          [`${holderKey}_validated`]: true,
          [`${holderKey}_details`]: {
            client_name: response.data.client_name || '',
            client_id: response.data.client_id || '',
            dp_id: response.data.dp_id || '',
            email: response.data.email || '',
            mobile: response.data.mobile || '',
            address: response.data.address || '',
          },
          // Auto-populate existing values from CM
          [`${holderKey}_email_from_cm`]: response.data.email || '',
          [`${holderKey}_mobile_from_cm`]: response.data.mobile || '',
          [`${holderKey}_address_from_cm`]: response.data.address || '',
        };

        // Auto-populate 2nd and 3rd holders if searching 1st holder
        if (holder === '1st_holder') {
          // Auto-populate 1st nominee from CM if available
          if (response.data.first_nominee_name) {
            updates['first_nominee_name'] = response.data.first_nominee_name;
            updates['first_nominee_from_cm'] = true; // Flag to show it's from CM
            console.log('✓ Nominee name auto-populated from CM:', response.data.first_nominee_name);
          } else {
            updates['first_nominee_from_cm'] = false;
            console.log('⚠ No nominee name found in CM response');
          }

          // Always reset 2nd holder on new search
          if (response.data.second_holder_name) {
            updates['second_holder_validated'] = true;
            updates['second_holder_name'] = response.data.second_holder_name;
            updates['second_holder_details'] = {
              client_name: response.data.second_holder_name,
              client_id: '',
              dp_id: '',
              email: response.data.second_holder_email || '',
              mobile: response.data.second_holder_mobile || '',
              address: response.data.second_holder_address || '',
            };
            updates['second_holder_pan'] = formData.first_holder_pan;
            // Store CM values for auto-population
            updates['second_holder_email_from_cm'] = response.data.second_holder_email || '';
            updates['second_holder_mobile_from_cm'] = response.data.second_holder_mobile || '';
            updates['second_holder_address_from_cm'] = response.data.second_holder_address || '';
          } else {
            updates['second_holder_validated'] = false;
            updates['second_holder_name'] = '';
            updates['second_holder_details'] = {};
            updates['second_holder_pan'] = '';
          }

          // Always reset 3rd holder on new search
          if (response.data.third_holder_name) {
            updates['third_holder_validated'] = true;
            updates['third_holder_name'] = response.data.third_holder_name;
            updates['third_holder_details'] = {
              client_name: response.data.third_holder_name,
              client_id: '',
              dp_id: '',
              email: response.data.third_holder_email || '',
              mobile: response.data.third_holder_mobile || '',
              address: response.data.third_holder_address || '',
            };
            updates['third_holder_pan'] = formData.first_holder_pan;
            // Store CM values for auto-population
            updates['third_holder_email_from_cm'] = response.data.third_holder_email || '';
            updates['third_holder_mobile_from_cm'] = response.data.third_holder_mobile || '';
            updates['third_holder_address_from_cm'] = response.data.third_holder_address || '';
          } else {
            updates['third_holder_validated'] = false;
            updates['third_holder_name'] = '';
            updates['third_holder_details'] = {};
            updates['third_holder_pan'] = '';
          }
        }

        console.log('Updates object:', updates);
        console.log('Updates includes first_nominee_name?:', 'first_nominee_name' in updates);

        setFormData(prev => {
          // If this is 1st holder search, clear all modification data from previous PAN
          const clearedData = holder === '1st_holder' ? clearAllModificationData() : {};

          const newData = {
            ...prev,
            ...clearedData,
            ...updates
          };
          console.log('New formData after update:', { first_nominee_name: newData.first_nominee_name, first_nominee_from_cm: newData.first_nominee_from_cm });
          return newData;
        });

        setErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors[panField];
          return newErrors;
        });

        // Reset tab index to 1st holder if this is a 1st holder search
        if (holder === '1st_holder') {
          setCurrentTabIndex(0);
          setActiveTab('1st_holder');
        }
      } else {
        setErrors(prev => ({
          ...prev,
          [panField]: response.data.error || 'Client not found'
        }));
        setFormData(prev => ({
          ...prev,
          [`${holderKey}_validated`]: false,
          [`${holderKey}_details`]: {}
        }));
      }
    } catch (error) {
      setErrors(prev => ({
        ...prev,
        [panField]: error.response?.data?.error || 'Error searching client'
      }));
      setFormData(prev => ({
        ...prev,
        [`${holderKey}_validated`]: false,
        [`${holderKey}_details`]: {}
      }));
    } finally {
      setIsSearching(prev => ({
        ...prev,
        [holder]: false
      }));
    }
  };

  const validators = {
    email: (email) => {
      if (!email) return null;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email) ? null : 'Invalid email format';
    },
    mobile: (mobile) => {
      if (!mobile) return null;
      // Support both Indian (10 digits: 6-9XXXXXXXXX) and International (+CC XXXXXXXXXX) formats
      const cleanedMobile = mobile.replace(/[\s\-\(\)\.]/g, '');

      // Indian mobile: 10 digits starting with 6-9
      const indianRegex = /^[6-9]\d{9}$/;
      // International mobile: +1 to +999 country code followed by digits (min 8 digits, max 15 total)
      const internationalRegex = /^\+\d{1,3}\d{8,14}$/;

      const isValid = indianRegex.test(cleanedMobile) || internationalRegex.test(mobile);
      return isValid ? null : 'Mobile number should be 10 Indian digits (6-9XXXXXXXXX) or international format (+CC XXXXXXXXXX)';
    },
    name: (name) => {
      if (!name) return null;
      if (name.trim().length < 2) return 'Name should be at least 2 characters';
      if (name.trim().length > 100) return 'Name should not exceed 100 characters';
      if (!/^[a-zA-Z\s\-'.]*$/.test(name)) return 'Name should contain only letters, spaces, hyphens, and apostrophes';
      return null;
    },
    address: (address) => {
      if (!address) return null;
      if (address.trim().length < 5) return 'Address should be at least 5 characters';
      if (address.trim().length > 500) return 'Address should not exceed 500 characters';
      return null;
    },
    sharePercentage: (share) => {
      if (!share) return null;
      const shareNum = parseFloat(share);
      if (isNaN(shareNum)) return 'Share percentage must be a number';
      if (shareNum < 0 || shareNum > 100) return 'Share percentage must be between 0 and 100';
      return null;
    },
    pan: (pan) => {
      if (!pan) return null;
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      return panRegex.test(pan.toUpperCase()) ? null : 'PAN format should be like AAAAA0000A';
    },
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate nominee data
    const nominees = [
      { keyPrefix: '1st_nominee', dbPrefix: 'first_nominee', name: '1st Nominee' },
      { keyPrefix: '2nd_nominee', dbPrefix: 'second_nominee', name: '2nd Nominee' },
      { keyPrefix: '3rd_nominee', dbPrefix: 'third_nominee', name: '3rd Nominee' },
    ];

    let activeNominees = 0;
    let totalShare = 0;

    nominees.forEach((nominee) => {
      // Convert to backend format (1st_nominee -> first_nominee)
      const dbPrefix = nominee.dbPrefix;

      // Check if any change type is selected or any data is filled
      const emailChangeType = formData[`${dbPrefix}_email_change_type`];
      const emailValue = formData[`${dbPrefix}_email`];
      const emailExisting = formData[`${dbPrefix}_email_existing`];

      const mobileChangeType = formData[`${dbPrefix}_mobile_change_type`];
      const mobileValue = formData[`${dbPrefix}_mobile`];
      const mobileExisting = formData[`${dbPrefix}_mobile_existing`];

      const share = formData[`${dbPrefix}_share_percentage`];
      const dob = formData[`${dbPrefix}_dob`];
      const guardianName = formData[`${dbPrefix}_guardian_name`];
      const guardianEmail = formData[`${dbPrefix}_guardian_email`];
      const guardianMobile = formData[`${dbPrefix}_guardian_mobile`];

      const hasAnyChange = emailChangeType || emailValue || emailExisting || mobileChangeType || mobileValue || mobileExisting || share || dob || guardianName || guardianEmail || guardianMobile;

      if (!hasAnyChange) return; // Skip if no changes selected

      activeNominees++;
      const name = formData[`${dbPrefix}_name`];

      // If any change is made, name is mandatory
      if (!name) {
        newErrors[`${dbPrefix}_name`] = `${nominee.name} name is required`;
      } else {
        const nameError = validators.name(name);
        if (nameError) newErrors[`${dbPrefix}_name`] = nameError;
      }

      // Validate email if email change type is selected
      if (emailChangeType) {
        const email = formData[`${dbPrefix}_email`];
        if (!email) {
          newErrors[`${dbPrefix}_email`] = `${nominee.name} email is required`;
        } else {
          const emailError = validators.email(email);
          if (emailError) newErrors[`${dbPrefix}_email`] = emailError;
        }
      }

      // Validate mobile if mobile change type is selected
      if (mobileChangeType) {
        const mobile = formData[`${dbPrefix}_mobile`];
        if (!mobile) {
          newErrors[`${dbPrefix}_mobile`] = `${nominee.name} mobile is required`;
        } else {
          const mobileError = validators.mobile(mobile);
          if (mobileError) newErrors[`${dbPrefix}_mobile`] = mobileError;
        }
      }

      // Validate share percentage (always required if any other change is selected)
      if (!share) {
        newErrors[`${dbPrefix}_share_percentage`] = `${nominee.name} share percentage is required`;
      } else {
        const shareError = validators.sharePercentage(share);
        if (shareError) {
          newErrors[`${dbPrefix}_share_percentage`] = shareError;
        } else {
          totalShare += parseFloat(share);
        }
      }

      // Validate guardian details if nominee is minor (age < 18)
      if (dob) {
        const dobDate = new Date(dob);
        const today = new Date();
        const age = today.getFullYear() - dobDate.getFullYear() - (today < new Date(today.getFullYear(), dobDate.getMonth(), dobDate.getDate()) ? 1 : 0);

        if (age < 18) {
          const guardianNameValue = formData[`${dbPrefix}_guardian_name`];
          const guardianEmailValue = formData[`${dbPrefix}_guardian_email`];
          const guardianMobileValue = formData[`${dbPrefix}_guardian_mobile`];

          // Guardian name is mandatory for minors
          if (!guardianNameValue) {
            newErrors[`${dbPrefix}_guardian_name`] = `${nominee.name} guardian name is required (minor)`;
          } else {
            const guardianNameError = validators.name(guardianNameValue);
            if (guardianNameError) newErrors[`${dbPrefix}_guardian_name`] = guardianNameError;
          }

          // Guardian email is mandatory for minors
          if (!guardianEmailValue) {
            newErrors[`${dbPrefix}_guardian_email`] = `${nominee.name} guardian email is required (minor)`;
          } else {
            const guardianEmailError = validators.email(guardianEmailValue);
            if (guardianEmailError) newErrors[`${dbPrefix}_guardian_email`] = guardianEmailError;
          }

          // Guardian mobile is mandatory for minors
          if (!guardianMobileValue) {
            newErrors[`${dbPrefix}_guardian_mobile`] = `${nominee.name} guardian mobile is required (minor)`;
          } else {
            const guardianMobileError = validators.mobile(guardianMobileValue);
            if (guardianMobileError) newErrors[`${dbPrefix}_guardian_mobile`] = guardianMobileError;
          }
        }
      }
    });

    // Check if total is 100 only if nominees are present
    if (activeNominees > 0 && Math.abs(totalShare - 100) > 0.01) {
      newErrors.nominee_share_total = `Total share percentage must equal 100% (currently ${totalShare.toFixed(2)}%)`;
    }

    // Validate holder details
    ['1st_holder', '2nd_holder', '3rd_holder'].forEach(holder => {
      const holderKey = convertHolderFormat(holder);

      // Check if holder is auto-populated from CM
      const isAutopopulated = formData[`${holderKey}_validated`] && formData[`${holderKey}_details`];

      const changeTypes = {
        address: formData[`${holderKey}_address_change_type`],
        email: formData[`${holderKey}_email_change_type`],
        mobile: formData[`${holderKey}_mobile_change_type`],
        others: formData[`${holderKey}_others_change_type`],
      };

      // Check if ANY change is selected for this holder (including income)
      const hasAnyChange = changeTypes.address || changeTypes.email || changeTypes.mobile || changeTypes.others || formData[`${holderKey}_income`];
      console.log(`🔍 ${holder}: hasAnyChange=${hasAnyChange}, autopopulated=${isAutopopulated}, changes=`, changeTypes);

      // For 2nd and 3rd holders, PAN is mandatory if any changes are entered (including income)
      if ((holder === '2nd_holder' || holder === '3rd_holder') && hasAnyChange) {
        const panValue = formData[`${holderKey}_pan`];
        if (!panValue || panValue.trim() === '') {
          newErrors[`${holderKey}_pan`] = `${holder.replace('_', ' ').toUpperCase()} PAN is required when changes are selected`;
        } else {
          const panError = validators.pan(panValue);
          if (panError) newErrors[`${holderKey}_pan`] = panError;
        }
      }

      // Validate name only if manually entered (not auto-populated)
      if (hasAnyChange && (holder !== '1st_holder') && !isAutopopulated) {
        console.log(`⚠️  ${holder} has changes and is manually entered - validating name`);
        const name = formData[`${holderKey}_name`];
        if (!name) {
          newErrors[`${holderKey}_name`] = `${holder.replace('_', ' ').toUpperCase()} name is required`;
        } else {
          const nameError = validators.name(name);
          if (nameError) newErrors[`${holderKey}_name`] = nameError;
        }
      }

      // Validate address if change type is selected
      if (changeTypes.address) {
        if (!formData[`${holderKey}_address_new`] || formData[`${holderKey}_address_new`].trim() === '') {
          newErrors[`${holderKey}_address_new`] = `${holder.replace('_', ' ').toUpperCase()} address is required when change type is selected`;
        } else {
          const addressError = validators.address(formData[`${holderKey}_address_new`]);
          if (addressError) newErrors[`${holderKey}_address_new`] = addressError;
        }
      }

      // Validate email if change type is selected
      if (changeTypes.email) {
        if (!formData[`${holderKey}_email_new`] || formData[`${holderKey}_email_new`].trim() === '') {
          newErrors[`${holderKey}_email_new`] = `${holder.replace('_', ' ').toUpperCase()} email is required when change type is selected`;
        } else {
          const emailError = validators.email(formData[`${holderKey}_email_new`]);
          if (emailError) newErrors[`${holderKey}_email_new`] = emailError;
        }
      }

      // Validate mobile if change type is selected
      if (changeTypes.mobile) {
        if (!formData[`${holderKey}_mobile_new`] || formData[`${holderKey}_mobile_new`].trim() === '') {
          newErrors[`${holderKey}_mobile_new`] = `${holder.replace('_', ' ').toUpperCase()} mobile is required when change type is selected`;
        } else {
          const mobileError = validators.mobile(formData[`${holderKey}_mobile_new`]);
          if (mobileError) newErrors[`${holderKey}_mobile_new`] = mobileError;
        }
      }

      // Validate others if change type is selected
      if (changeTypes.others) {
        if (!formData[`${holderKey}_others_new`] || formData[`${holderKey}_others_new`].trim() === '') {
          newErrors[`${holderKey}_others_new`] = `${holder.replace('_', ' ').toUpperCase()} details are required when change type is selected`;
        } else {
          const othersError = validators.address(formData[`${holderKey}_others_new`]);
          if (othersError) newErrors[`${holderKey}_others_new`] = othersError;
        }
      }
    });

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    console.log('🔄 SUBMIT CLICKED - Running validation...');
    const validationErrors = validateForm();
    console.log('✅ Validation complete. Errors found:', validationErrors);
    console.log('📊 Error count:', Object.keys(validationErrors).length);
    console.log('📋 Error keys:', Object.keys(validationErrors));

    if (Object.keys(validationErrors).length > 0) {
      console.log('❌ BLOCKING SUBMISSION - Validation failed');
      console.log('🔴 Full errors object:', validationErrors);
      setErrors(validationErrors);
      setIsSubmitting(false);

      const firstErrorField = Object.keys(validationErrors)[0];
      console.log('📍 First error field:', firstErrorField);
      const errorElement = document.querySelector(`input[name="${firstErrorField}"], textarea[name="${firstErrorField}"], select[name="${firstErrorField}"]`);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        errorElement.focus();
      }
      return;
    }

    console.log('✅ VALIDATION PASSED - Proceeding with submission');

    try {
      const submitData = new FormData();

      // Add first holder's details as global client info
      if (formData.first_holder_validated && formData.first_holder_details.client_name) {
        submitData.append('client_name', formData.first_holder_details.client_name);
        submitData.append('client_id', formData.first_holder_details.client_id || '');
        submitData.append('dp_id', formData.first_holder_details.dp_id || '');
        submitData.append('pan', formData.first_holder_pan);
      }

      const submittedFields = {};
      Object.keys(formData).forEach(key => {
        // Exclude internal state fields, but include nominee fields and 2nd/3rd holder data
        const isInternalState = key.includes('_details') || key.includes('_validated') ||
                               key.includes('_from_cm') || // Exclude CM tracking fields
                               key === 'first_holder_pan' || // Exclude 1st holder PAN (already sent as global pan)
                               key === 'additional_attachments'; // Handle files separately

        if (!isInternalState && formData[key] !== null && formData[key] !== '') {
          // Convert nominee field names from 1st_nominee to first_nominee format
          const convertedKey = key.includes('nominee') ? convertNomineeFormat(key) : key;
          submitData.append(convertedKey, formData[key]);
          submittedFields[convertedKey] = formData[key];
        }
      });
      console.log('📤 Submitted fields:', submittedFields);

      // Handle additional attachments
      if (formData.additional_attachments && formData.additional_attachments.length > 0) {
        Array.from(formData.additional_attachments).forEach((file, index) => {
          submitData.append(`additional_attachment_${index}`, file);
        });
      }

      console.log('📤 Sending form to backend...');
      const response = await axios.post(
        `${API_BASE_URL}/api/modification-form/submit/`,
        submitData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      console.log('📥 Backend response:', response.data);

      if (response.data.success) {
        console.log('✅ SUBMISSION SUCCESS!');
        setSuccessMessage('Modification form submitted successfully!');
        setTimeout(() => {
          history.push('/');
        }, 2000);
      } else {
        console.log('❌ SUBMISSION FAILED - Backend returned error');
        const backendErrors = response.data.errors || { submit: 'Failed to submit form' };
        console.log('🔴 Backend errors:', backendErrors);
        setErrors(backendErrors);
        setIsSubmitting(false);

        const firstErrorField = Object.keys(backendErrors)[0];
        console.log('📍 First error field from backend:', firstErrorField);
        const errorElement = document.querySelector(`input[name="${firstErrorField}"], textarea[name="${firstErrorField}"], select[name="${firstErrorField}"]`);
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          errorElement.focus();
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    } catch (error) {
      console.error('💥 NETWORK ERROR while submitting:', error);
      console.error('📌 Error response:', error.response?.data);
      console.error('📌 Error status:', error.response?.status);
      console.error('📌 Error message:', error.message);
      setErrors({
        submit: error.response?.data?.error || 'Error submitting form. Please try again.'
      });
      setIsSubmitting(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const renderFieldRow = (fieldName, fieldType, changeTypeKey, existingKey, newKey, cmValue = '') => {
    const changeType = formData[changeTypeKey];

    // Determine if current field should be editable based on cmValue
    // If cmValue exists (from CM), make it read-only; else editable
    const hasCmValue = cmValue && cmValue.trim() !== '';
    const isEditableBoth = !hasCmValue;

    if (!changeType) return null;

    if (changeType === 'addition') {
      return (
        <div className="form-group">
          <label>{fieldName}</label>
          {fieldType === 'textarea' ? (
            <textarea
              name={newKey}
              value={formData[newKey]}
              onChange={handleInputChange}
              onBlur={handleFieldBlur}
              placeholder={`Enter new ${fieldName.toLowerCase()}`}
              style={errors[newKey] ? { borderColor: '#d32f2f' } : {}}
            />
          ) : (
            <input
              type={fieldType}
              name={newKey}
              value={formData[newKey]}
              onChange={fieldType === 'tel' ? (e) => {
                e.target.value = e.target.value.replace(/[^0-9+\-\s]/g, '');
                handleInputChange(e);
              } : handleInputChange}
              onBlur={handleFieldBlur}
              placeholder={`Enter new ${fieldName.toLowerCase()}`}
              style={errors[newKey] ? { borderColor: '#d32f2f' } : {}}
              inputMode={fieldType === 'tel' ? 'numeric' : undefined}
            />
          )}
          {errors[newKey] && (
            <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
              {errors[newKey]}
            </small>
          )}
        </div>
      );
    }

    if (changeType === 'modification') {
      return (
        <div className="form-row">
          <div className="form-group">
            <label>Current {fieldName}</label>
            {fieldType === 'textarea' ? (
              <textarea
                name={existingKey}
                value={isEditableBoth ? formData[existingKey] : cmValue}
                onChange={isEditableBoth ? handleInputChange : undefined}
                onBlur={isEditableBoth ? handleFieldBlur : undefined}
                disabled={!isEditableBoth}
                style={isEditableBoth ? (errors[existingKey] ? { borderColor: '#d32f2f' } : {}) : { background: '#f5f5f5', cursor: 'not-allowed', color: '#666' }}
              />
            ) : (
              <input
                type={fieldType}
                name={existingKey}
                value={isEditableBoth ? formData[existingKey] : cmValue}
                onChange={isEditableBoth ? (fieldType === 'tel' ? (e) => {
                  e.target.value = e.target.value.replace(/[^0-9+\-\s]/g, '');
                  handleInputChange(e);
                } : handleInputChange) : undefined}
                onBlur={isEditableBoth ? handleFieldBlur : undefined}
                disabled={!isEditableBoth}
                style={isEditableBoth ? (errors[existingKey] ? { borderColor: '#d32f2f' } : {}) : { background: '#f5f5f5', cursor: 'not-allowed', color: '#666' }}
                inputMode={fieldType === 'tel' ? 'numeric' : undefined}
              />
            )}
            {isEditableBoth && errors[existingKey] && (
              <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                {errors[existingKey]}
              </small>
            )}
          </div>
          <div className="form-group">
            <label>New {fieldName}</label>
            {fieldType === 'textarea' ? (
              <textarea
                name={newKey}
                value={formData[newKey]}
                onChange={handleInputChange}
                onBlur={handleFieldBlur}
                placeholder={`Enter new ${fieldName.toLowerCase()}`}
                style={errors[newKey] ? { borderColor: '#d32f2f' } : {}}
              />
            ) : (
              <input
                type={fieldType}
                name={newKey}
                value={formData[newKey]}
                onChange={fieldType === 'tel' ? (e) => {
                  e.target.value = e.target.value.replace(/[^0-9+\-\s]/g, '');
                  handleInputChange(e);
                } : handleInputChange}
                onBlur={handleFieldBlur}
                placeholder={`Enter new ${fieldName.toLowerCase()}`}
                style={errors[newKey] ? { borderColor: '#d32f2f' } : {}}
                inputMode={fieldType === 'tel' ? 'numeric' : undefined}
              />
            )}
            {errors[newKey] && (
              <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                {errors[newKey]}
              </small>
            )}
          </div>
        </div>
      );
    }

    return null;
  };

  const renderSection = (section, holder) => {
    const holderKey = convertHolderFormat(holder);
    const isExpanded = expandedSection === `${holder}-${section}`;
    const holderDetails = formData[`${holderKey}_details`] || {};

    return (
      <div key={section} className="modification-holder-section">
        <button
          type="button"
          className={`holder-toggle ${isExpanded ? 'expanded' : ''}`}
          onClick={() => setExpandedSection(isExpanded ? null : `${holder}-${section}`)}
        >
          <span className="holder-name">
            {section === 'address' && 'Address'}
            {section === 'email' && 'Email'}
            {section === 'mobile' && 'Mobile'}
            {section === 'income' && 'Income Details'}
            {section === 'others' && 'Others'}
          </span>
          <span className="toggle-icon">{isExpanded ? '−' : '+'}</span>
        </button>

        {isExpanded && (
          <div className="holder-content">
            {section === 'address' && (
              <>
                <div className="form-group">
                  <label>Address - Change Type</label>
                  <select
                    name={`${holderKey}_address_change_type`}
                    value={formData[`${holderKey}_address_change_type`]}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Type</option>
                    {CHANGE_TYPES.map(type => (
                      <option key={type.value} value={type.value}>{type.label}</option>
                    ))}
                  </select>
                </div>
                {renderFieldRow('Address', 'textarea', `${holderKey}_address_change_type`, `${holderKey}_address_existing`, `${holderKey}_address_new`, holderDetails.address || '')}
              </>
            )}

            {section === 'email' && (
              <>
                <div className="form-group">
                  <label>Email ID - Change Type</label>
                  <select
                    name={`${holderKey}_email_change_type`}
                    value={formData[`${holderKey}_email_change_type`]}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Type</option>
                    {CHANGE_TYPES.map(type => (
                      <option key={type.value} value={type.value}>{type.label}</option>
                    ))}
                  </select>
                </div>
                {renderFieldRow('Email', 'email', `${holderKey}_email_change_type`, `${holderKey}_email_existing`, `${holderKey}_email_new`, holderDetails.email || '')}
              </>
            )}

            {section === 'mobile' && (
              <>
                <div className="form-group">
                  <label>Mobile No. - Change Type</label>
                  <select
                    name={`${holderKey}_mobile_change_type`}
                    value={formData[`${holderKey}_mobile_change_type`]}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Type</option>
                    {CHANGE_TYPES.map(type => (
                      <option key={type.value} value={type.value}>{type.label}</option>
                    ))}
                  </select>
                </div>
                {renderFieldRow('Mobile No.', 'tel', `${holderKey}_mobile_change_type`, `${holderKey}_mobile_existing`, `${holderKey}_mobile_new`, holderDetails.mobile || '')}
              </>
            )}

            {section === 'income' && (
              <div className="form-group">
                <label>Income Range</label>
                <select
                  name={`${holderKey}_income`}
                  value={formData[`${holderKey}_income`]}
                  onChange={handleInputChange}
                  style={errors[`${holderKey}_income`] ? { borderColor: '#d32f2f' } : {}}
                >
                  <option value="">Select Income Range</option>
                  {INCOME_RANGES.map(income => (
                    <option key={income.value} value={income.value}>{income.label}</option>
                  ))}
                </select>
                {errors[`${holderKey}_income`] && (
                  <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                    {errors[`${holderKey}_income`]}
                  </small>
                )}
              </div>
            )}

            {section === 'others' && (
              <>
                <div className="form-group">
                  <label>Others - Change Type</label>
                  <select
                    name={`${holderKey}_others_change_type`}
                    value={formData[`${holderKey}_others_change_type`]}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Type</option>
                    {CHANGE_TYPES.map(type => (
                      <option key={type.value} value={type.value}>{type.label}</option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Please Specify Other Changes</label>
                  <input
                    type="text"
                    name={`${holderKey}_others_specify`}
                    value={formData[`${holderKey}_others_specify`]}
                    onChange={handleInputChange}
                  />
                </div>

                {renderFieldRow('Details', 'textarea', `${holderKey}_others_change_type`, `${holderKey}_others_existing`, `${holderKey}_others_new`, '', true)}
              </>
            )}
          </div>
        )}
      </div>
    );
  };

  const renderHolderTab = (holder) => {
    const holderKey = convertHolderFormat(holder);
    const panField = `${holderKey}_pan`;
    const isValidated = formData[`${holderKey}_validated`];
    const details = formData[`${holderKey}_details`] || {};
    const isAutoPopulated = isValidated && holder !== '1st_holder';

    return (
      <div key={holder} className="holder-tab-content">
        {/* PAN Input Section */}
        <div className="form-section">
          {holder === '1st_holder' ? (
            <>
              <h2>Verify {holder.replace('_', ' ')}</h2>
              <p className="section-info">⚠️ Enter PAN to fetch client details</p>

              <div className="form-row">
                <div className="form-group" style={{ position: 'relative' }}>
                  <label>
                    PAN <span style={{ color: '#d32f2f' }}>*</span>
                  </label>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
                    <input
                      type="text"
                      name={panField}
                      value={formData[panField]}
                      onChange={handleInputChange}
                      onBlur={handleFieldBlur}
                      placeholder="e.g., AAAAA0000A"
                      style={errors[panField] ? { borderColor: '#d32f2f', flex: 1 } : { flex: 1 }}
                    />
                    <button
                      type="button"
                      onClick={() => handleSearchClient(holder)}
                      disabled={isSearching[holder]}
                      style={{
                        padding: '10px 20px',
                        background: '#033132',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: isSearching[holder] ? 'not-allowed' : 'pointer',
                        fontWeight: 'bold'
                      }}
                    >
                      {isSearching[holder] ? 'Searching...' : 'Search'}
                    </button>
                  </div>
                  {errors[panField] && (
                    <div style={{
                      display: 'block',
                      marginTop: '15px',
                      marginLeft: '-10px',
                      marginRight: '-10px',
                      padding: '14px 16px',
                      borderRadius: '4px',
                      fontSize: '14px',
                      width: 'calc(100% + 20px)',
                      lineHeight: '1.6',
                      ...(errors[panField].includes('Non-Individual') ? {
                        background: '#fef3cd',
                        border: '1px solid #ffc107',
                        color: '#856404'
                      } : {
                        background: '#f8d7da',
                        border: '1px solid #f5c6cb',
                        color: '#721c24'
                      })
                    }}>
                      {errors[panField].includes('Non-Individual') ? (
                        <>
                          If the applicant is a Minor / Non-Individual, please do not proceed further and kindly contact us at <a href="mailto:ops@agreyacapital.com" style={{ color: '#856404', textDecoration: 'underline', fontWeight: 'bold' }}>ops@agreyacapital.com</a>. Additional information to be separately obtained from NRI applicants.
                        </>
                      ) : (
                        errors[panField]
                      )}
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              <h2>{holder.replace('_', ' ').toUpperCase()}</h2>
              {!isAutoPopulated && (
                <p className="section-info">📝 Enter {holder.replace('_', ' ')} details</p>
              )}

              {!isAutoPopulated && (
                <div className="form-row">
                  <div className="form-group">
                    <label>PAN</label>
                    <input
                      type="text"
                      name={panField}
                      value={formData[panField]}
                      onChange={handleInputChange}
                      onBlur={handleFieldBlur}
                      placeholder="e.g., AAAAA0000A"
                      style={errors[panField] ? { borderColor: '#d32f2f' } : {}}
                    />
                    {errors[panField] && (
                      <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                        {errors[panField]}
                      </small>
                    )}
                  </div>
                  <div className="form-group">
                    <label>
                      {holder.replace('_', ' ')} Name
                      {(formData[`${holderKey}_address_change_type`] ||
                        formData[`${holderKey}_email_change_type`] ||
                        formData[`${holderKey}_mobile_change_type`] ||
                        formData[`${holderKey}_others_change_type`]) && (
                        <span style={{ color: '#d32f2f' }}>*</span>
                      )}
                    </label>
                    <input
                      type="text"
                      name={`${holderKey}_name`}
                      value={formData[`${holderKey}_name`] || ''}
                      onChange={handleInputChange}
                      placeholder="Enter name"
                      style={errors[`${holderKey}_name`] ? { borderColor: '#d32f2f' } : {}}
                    />
                    {errors[`${holderKey}_name`] && (
                      <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                        {errors[`${holderKey}_name`]}
                      </small>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </div>

          {/* Client Details */}
          {isValidated && (
            <div style={{ background: '#f0f8f8', padding: '16px', borderRadius: '4px', marginTop: isAutoPopulated ? '0' : '20px', border: '1px solid #033132' }}>
              {isAutoPopulated && (
                <div style={{ background: '#e3f2fd', padding: '10px', borderRadius: '4px', marginBottom: '12px', fontSize: '13px', color: '#1976d2', border: '1px solid #90caf9' }}>
                  ✓ Auto-populated from 1st Holder
                </div>
              )}
              <h3 style={{ margin: '0 0 12px 0', color: '#033132' }}>{holder.replace('_', ' ').toUpperCase()} Details</h3>

              {holder === '1st_holder' ? (
                <>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Client Name</label>
                      <input
                        type="text"
                        value={details.client_name || ''}
                        disabled
                        style={{ background: '#f5f5f5', cursor: 'not-allowed' }}
                      />
                    </div>
                    <div className="form-group">
                      <label>Client ID</label>
                      <input
                        type="text"
                        value={details.client_id || ''}
                        disabled
                        style={{ background: '#f5f5f5', cursor: 'not-allowed' }}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>DP ID</label>
                      <input
                        type="text"
                        value={details.dp_id || ''}
                        disabled
                        style={{ background: '#f5f5f5', cursor: 'not-allowed' }}
                      />
                    </div>
                    {details.email && (
                      <div className="form-group">
                        <label>Email</label>
                        <input
                          type="text"
                          value={details.email}
                          disabled
                          style={{ background: '#f5f5f5', cursor: 'not-allowed' }}
                        />
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <div className="form-row">
                  <div className="form-group">
                    <label>{holder.replace('_', ' ')} Name</label>
                    <input
                      type="text"
                      value={details.client_name || ''}
                      disabled
                      style={{ background: '#f5f5f5', cursor: 'not-allowed' }}
                    />
                  </div>
                </div>
              )}
            </div>
          )}

        {/* Sections */}
        {(isValidated || (holder !== '1st_holder' && !isAutoPopulated)) && (
          <div className="form-section">
            <h2>Details for Change</h2>
            <p className="section-info">📝 Fill only the fields you want to update. All fields are optional.</p>

            {SECTIONS.map(section => renderSection(section.value, holder))}
          </div>
        )}
      </div>
    );
  };

  const renderNomineeTab = (nominee) => {
    // Convert frontend format (1st_nominee) to backend format (first_nominee)
    const nomineeKey = convertNomineeFormat(nominee);
    const addCheckboxKey = `${nomineeKey}_add`;
    const isNomineeAdded = formData[addCheckboxKey];

    const first = parseFloat(formData['first_nominee_share_percentage']) || 0;
    const second = parseFloat(formData['second_nominee_share_percentage']) || 0;
    const third = parseFloat(formData['third_nominee_share_percentage']) || 0;

    // Count active nominees (those with checkbox checked)
    const hasFirst = formData['1st_nominee_add'];
    const hasSecond = formData['2nd_nominee_add'];
    const hasThird = formData['3rd_nominee_add'];

    const activeCount = (hasFirst ? 1 : 0) + (hasSecond ? 1 : 0) + (hasThird ? 1 : 0);
    const suggestedPercentage = activeCount > 0 ? (100 / activeCount).toFixed(2) : '0';

    const totalShare = (first + second + third).toFixed(2);

    // Debug logging
    console.log(`[${nominee}] Full formData keys containing nominee:`, Object.keys(formData).filter(k => k.includes('nominee')));
    console.log(`[${nominee}] Name: "${formData[`${nomineeKey}_name`]}", From CM: ${formData[`${nomineeKey}_from_cm`]}`);
    console.log(`[${nominee}] All nominee values:`, {
      first_nominee_name: formData.first_nominee_name,
      first_nominee_from_cm: formData.first_nominee_from_cm,
      second_nominee_name: formData.second_nominee_name,
      third_nominee_name: formData.third_nominee_name
    });

    return (
      <div key={nominee} className="holder-tab-content">
        <div className="form-section">

          {/* Nominee Name - Always visible, mandatory if ANY other field is filled */}
          <div className="form-group" style={{ marginBottom: '20px' }}>
            <label>
              {nominee.replace('_', ' ').toUpperCase()} Name
              {(formData[`${nomineeKey}_email_change_type`] ||
                formData[`${nomineeKey}_mobile_change_type`] ||
                formData[`${nomineeKey}_share_percentage`] ||
                formData[`${nomineeKey}_dob`] ||
                formData[`${nomineeKey}_guardian_name`] ||
                formData[`${nomineeKey}_guardian_email`] ||
                formData[`${nomineeKey}_guardian_mobile`]) && (
                <span style={{ color: '#d32f2f' }}>*</span>
              )}
            </label>
            <input
              type="text"
              name={`${nomineeKey}_name`}
              value={formData[`${nomineeKey}_name`] || ''}
              onChange={handleInputChange}
              onBlur={handleFieldBlur}
              placeholder="Enter nominee name"
              style={errors[`${nomineeKey}_name`] ? { borderColor: '#d32f2f' } : {}}
            />
            {errors[`${nomineeKey}_name`] && (
              <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                {errors[`${nomineeKey}_name`]}
              </small>
            )}
          </div>

          {/* Email - Change Type */}
          <div className="form-group">
            <label>Email - Change Type</label>
            <select
              name={`${nomineeKey}_email_change_type`}
              value={formData[`${nomineeKey}_email_change_type`] || ''}
              onChange={handleInputChange}
            >
              <option value="">Select Type</option>
              <option value="addition">Addition</option>
              <option value="modification">Modification</option>
            </select>
          </div>
          {formData[`${nomineeKey}_email_change_type`] && (
            <div className="form-row">
              {formData[`${nomineeKey}_email_change_type`] === 'modification' ? (
                <>
                  <div className="form-group">
                    <label>Current Email</label>
                    <input
                      type="email"
                      name={`${nomineeKey}_email_existing`}
                      value={formData[`${nomineeKey}_email_existing`] || ''}
                      onChange={handleInputChange}
                      onBlur={handleFieldBlur}
                      placeholder="Enter current email"
                      style={{
                        ...( errors[`${nomineeKey}_email_existing`] ? { borderColor: '#d32f2f' } : {}),
                        ...(formData[`${nomineeKey}_email_existing`] && !errors[`${nomineeKey}_email_existing`] ? { background: '#f5f5f5' } : {})
                      }}
                    />
                    {errors[`${nomineeKey}_email_existing`] && (
                      <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                        {errors[`${nomineeKey}_email_existing`]}
                      </small>
                    )}
                  </div>
                  <div className="form-group">
                    <label>New Email</label>
                    <input
                      type="email"
                      name={`${nomineeKey}_email`}
                      value={formData[`${nomineeKey}_email`] || ''}
                      onChange={handleInputChange}
                      onBlur={handleFieldBlur}
                      placeholder="Enter new email"
                      style={errors[`${nomineeKey}_email`] ? { borderColor: '#d32f2f' } : {}}
                    />
                    {errors[`${nomineeKey}_email`] && (
                      <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                        {errors[`${nomineeKey}_email`]}
                      </small>
                    )}
                  </div>
                </>
              ) : (
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name={`${nomineeKey}_email`}
                    value={formData[`${nomineeKey}_email`] || ''}
                    onChange={handleInputChange}
                    onBlur={handleFieldBlur}
                    placeholder="Enter email"
                    style={errors[`${nomineeKey}_email`] ? { borderColor: '#d32f2f' } : {}}
                  />
                  {errors[`${nomineeKey}_email`] && (
                    <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                      {errors[`${nomineeKey}_email`]}
                    </small>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Mobile - Change Type */}
          <div className="form-group">
            <label>Mobile - Change Type</label>
            <select
              name={`${nomineeKey}_mobile_change_type`}
              value={formData[`${nomineeKey}_mobile_change_type`] || ''}
              onChange={handleInputChange}
            >
              <option value="">Select Type</option>
              <option value="addition">Addition</option>
              <option value="modification">Modification</option>
            </select>
          </div>
          {formData[`${nomineeKey}_mobile_change_type`] && (
            <div className="form-row">
              {formData[`${nomineeKey}_mobile_change_type`] === 'modification' ? (
                <>
                  <div className="form-group">
                    <label>Current Mobile</label>
                    <input
                      type="tel"
                      name={`${nomineeKey}_mobile_existing`}
                      value={formData[`${nomineeKey}_mobile_existing`] || ''}
                      onChange={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9+\-\s]/g, '');
                        handleInputChange(e);
                      }}
                      onBlur={handleFieldBlur}
                      placeholder="Enter current mobile"
                      style={{
                        ...(errors[`${nomineeKey}_mobile_existing`] ? { borderColor: '#d32f2f' } : {}),
                        ...(formData[`${nomineeKey}_mobile_existing`] && !errors[`${nomineeKey}_mobile_existing`] ? { background: '#f5f5f5' } : {})
                      }}
                      inputMode="numeric"
                    />
                    {errors[`${nomineeKey}_mobile_existing`] && (
                      <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                        {errors[`${nomineeKey}_mobile_existing`]}
                      </small>
                    )}
                  </div>
                  <div className="form-group">
                    <label>New Mobile</label>
                    <input
                      type="tel"
                      name={`${nomineeKey}_mobile`}
                      value={formData[`${nomineeKey}_mobile`] || ''}
                      onChange={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9+\-\s]/g, '');
                        handleInputChange(e);
                      }}
                      onBlur={handleFieldBlur}
                      placeholder="Enter new mobile number"
                      style={errors[`${nomineeKey}_mobile`] ? { borderColor: '#d32f2f' } : {}}
                      inputMode="numeric"
                    />
                    {errors[`${nomineeKey}_mobile`] && (
                      <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                        {errors[`${nomineeKey}_mobile`]}
                      </small>
                    )}
                  </div>
                </>
              ) : (
                <div className="form-group">
                  <label>Mobile</label>
                  <input
                    type="tel"
                    name={`${nomineeKey}_mobile`}
                    value={formData[`${nomineeKey}_mobile`] || ''}
                    onChange={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9+\-\s]/g, '');
                      handleInputChange(e);
                    }}
                    onBlur={handleFieldBlur}
                    placeholder="Enter mobile number"
                    style={errors[`${nomineeKey}_mobile`] ? { borderColor: '#d32f2f' } : {}}
                    inputMode="numeric"
                  />
                  {errors[`${nomineeKey}_mobile`] && (
                    <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                      {errors[`${nomineeKey}_mobile`]}
                    </small>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Date of Birth */}
          <div className="form-group" style={{ marginBottom: '20px' }}>
            <label>Date of Birth </label>
            <input
              type="date"
              name={`${nomineeKey}_dob`}
              value={formData[`${nomineeKey}_dob`] || ''}
              onChange={handleInputChange}
              onBlur={handleFieldBlur}
              style={errors[`${nomineeKey}_dob`] ? { borderColor: '#d32f2f' } : {}}
            />
          </div>

          {/* Guardian Details - Show only if nominee is minor */}
          {formData[`${nomineeKey}_dob`] && (() => {
            const dob = new Date(formData[`${nomineeKey}_dob`]);
            const today = new Date();
            const age = today.getFullYear() - dob.getFullYear() - (today < new Date(today.getFullYear(), dob.getMonth(), dob.getDate()) ? 1 : 0);
            const isMinor = age < 18;

            return isMinor ? (
              <div className="form-section" style={{ background: '#fff3cd', padding: '14px', borderRadius: '4px', marginBottom: '20px', border: '1px solid #ffc107' }}>
                <h4 style={{ margin: '0 0 15px 0', color: '#856404' }}>⚠️ Guardian Details (Nominee is Minor - Age {age})</h4>
                <div className="form-group" style={{ marginBottom: '15px' }}>
                  <label>Guardian Name <span style={{ color: '#d32f2f' }}>*</span></label>
                  <input
                    type="text"
                    name={`${nomineeKey}_guardian_name`}
                    value={formData[`${nomineeKey}_guardian_name`] || ''}
                    onChange={handleInputChange}
                    onBlur={handleFieldBlur}
                    placeholder="Enter guardian name"
                    style={errors[`${nomineeKey}_guardian_name`] ? { borderColor: '#d32f2f' } : {}}
                  />
                  {errors[`${nomineeKey}_guardian_name`] && (
                    <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                      {errors[`${nomineeKey}_guardian_name`]}
                    </small>
                  )}
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Guardian Email <span style={{ color: '#d32f2f' }}>*</span></label>
                    <input
                      type="email"
                      name={`${nomineeKey}_guardian_email`}
                      value={formData[`${nomineeKey}_guardian_email`] || ''}
                      onChange={handleInputChange}
                      onBlur={handleFieldBlur}
                      placeholder="Enter email"
                      style={errors[`${nomineeKey}_guardian_email`] ? { borderColor: '#d32f2f' } : {}}
                    />
                    {errors[`${nomineeKey}_guardian_email`] && (
                      <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                        {errors[`${nomineeKey}_guardian_email`]}
                      </small>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Guardian Mobile <span style={{ color: '#d32f2f' }}>*</span></label>
                    <input
                      type="tel"
                      name={`${nomineeKey}_guardian_mobile`}
                      value={formData[`${nomineeKey}_guardian_mobile`] || ''}
                      onChange={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9+\-\s]/g, '');
                        handleInputChange(e);
                      }}
                      onBlur={handleFieldBlur}
                      placeholder="Enter mobile"
                      inputMode="numeric"
                      style={errors[`${nomineeKey}_guardian_mobile`] ? { borderColor: '#d32f2f' } : {}}
                    />
                    {errors[`${nomineeKey}_guardian_mobile`] && (
                      <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                        {errors[`${nomineeKey}_guardian_mobile`]}
                      </small>
                    )}
                  </div>
                </div>
              </div>
            ) : null;
          })()}

          {/* Share Percentage */}
          {activeCount > 0 && (
            <div style={{
              background: '#e3f2fd',
              border: '1px solid #90caf9',
              borderRadius: '4px',
              padding: '10px 14px',
              marginBottom: '15px',
              fontSize: '13px',
              color: '#1565c0'
            }}>
              <strong>Suggested split:</strong> If distributing equally among {activeCount} nominee(s): {suggestedPercentage}% each
            </div>
          )}
          <div className="form-row">
            <div className="form-group">
              <label>Share Percentage (%)</label>
              <input
                type="number"
                name={`${nomineeKey}_share_percentage`}
                value={formData[`${nomineeKey}_share_percentage`] || ''}
                onChange={handleInputChange}
                onBlur={handleFieldBlur}
                placeholder="0-100"
                min="0"
                max="100"
                step="0.01"
                style={errors[`${nomineeKey}_share_percentage`] ? { borderColor: '#d32f2f' } : {}}
              />
              {errors[`${nomineeKey}_share_percentage`] && (
                <small style={{ color: '#d32f2f', display: 'block', marginTop: '5px' }}>
                  {errors[`${nomineeKey}_share_percentage`]}
                </small>
              )}
            </div>
          </div>
        </div>

        {/* Total Share Percentage Display */}
        <div className="form-section">
          <div style={{ background: '#f5f5f5', padding: '16px', borderRadius: '4px', border: totalShare === '100.00' ? '2px solid #4caf50' : '2px solid #ff9800' }}>
            <h3 style={{ margin: '0 0 12px 0', color: totalShare === '100.00' ? '#4caf50' : '#ff9800' }}>
              Total Share: {totalShare}%
            </h3>
            <p style={{ margin: 0, fontSize: '13px', color: '#666' }}>
              {totalShare === '100.00' ? '✓ Total share equals 100%' : `⚠ Total share must equal 100% (currently ${totalShare}%)`}
            </p>
          </div>
          {errors.nominee_share_total && (
            <div style={{ background: '#ffebee', padding: '10px', borderRadius: '4px', marginTop: '10px', color: '#d32f2f', fontSize: '13px', border: '1px solid #ffcdd2' }}>
              {errors.nominee_share_total}
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderUploadsTab = () => {
    return (
      <div className="form-section" style={{ padding: '20px' }}>
        <h2 style={{ fontSize: '18px', marginBottom: '20px', color: '#033132' }}>Additional Attachments</h2>
        <p style={{ color: '#666', marginBottom: '20px', fontSize: '14px' }}>
          Upload any additional documents or attachments you would like to include with this modification request.
        </p>

        <div className="form-group" style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
            Attach Supporting Documents (Optional)
          </label>
          <input
            type="file"
            multiple
            accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
            onChange={(e) => {
              const files = e.target.files;
              if (files && files.length > 0) {
                // Validate files
                const maxSize = 10 * 1024 * 1024; // 10MB
                const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.doc', '.docx'];
                const validFiles = [];
                const errors = [];

                Array.from(files).forEach((file, index) => {
                  // Check file size
                  if (file.size > maxSize) {
                    errors.push(`${file.name}: File size exceeds 10MB`);
                    return;
                  }

                  // Check file extension
                  const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
                  if (!allowedExtensions.includes(fileExtension)) {
                    errors.push(`${file.name}: Invalid file type. Allowed: PDF, JPG, PNG, DOC, DOCX`);
                    return;
                  }

                  validFiles.push(file);
                });

                if (errors.length > 0) {
                  setErrors(prev => ({
                    ...prev,
                    file_upload: errors.join('\n')
                  }));
                } else {
                  setErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors.file_upload;
                    return newErrors;
                  });
                  setFormData(prev => ({
                    ...prev,
                    additional_attachments: validFiles
                  }));
                }
              }
            }}
            style={{
              display: 'block',
              width: '100%',
              padding: '10px',
              border: errors.file_upload ? '2px solid #d32f2f' : '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '14px',
              cursor: 'pointer'
            }}
          />
          <small style={{ color: '#666', display: 'block', marginTop: '8px' }}>
            Supported formats: PDF, JPG, PNG, DOC, DOCX (Max 10MB per file)
          </small>
          {errors.file_upload && (
            <small style={{ color: '#d32f2f', display: 'block', marginTop: '8px', whiteSpace: 'pre-wrap' }}>
              {errors.file_upload}
            </small>
          )}
        </div>

        {formData.additional_attachments && formData.additional_attachments.length > 0 && (
          <div style={{ background: '#e8f5e9', padding: '12px', borderRadius: '4px', marginBottom: '20px', border: '1px solid #c8e6c9' }}>
            <p style={{ margin: '0 0 10px 0', fontWeight: '500', color: '#2e7d32' }}>
              Files selected: {formData.additional_attachments.length}
            </p>
            <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '13px' }}>
              {Array.from(formData.additional_attachments).map((file, idx) => (
                <li key={idx} style={{ color: '#2e7d32', marginBottom: '5px' }}>
                  {file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)
                </li>
              ))}
            </ul>
          </div>
        )}

        <div style={{ background: '#fff3cd', border: '1px solid #ffc107', borderRadius: '4px', padding: '12px', color: '#856404', fontSize: '13px' }}>
          <strong>Note:</strong> Click the Submit button below to complete your modification request.
        </div>
      </div>
    );
  };

  return (
    <>
      <div style={{ maxWidth: '860px', margin: '100px auto', background: '#fff', borderRadius: '8px', boxShadow: '0 2px 12px rgba(0,0,0,0.1)', overflow: 'hidden' }} role="main">
        {/* Header */}
        <div style={{ background: '#C39639', color: '#fff', padding: '30px 25px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ flex: 1 }}>
            <h1 style={{ color: '#2c2c2c', marginBottom: '4px', margin: 0, fontSize: '20px', fontWeight: 700 }}>
              Agreya PMS: Direct-Onboarding Modification Form
            </h1>
            <p style={{ color: '#2a2a2a', margin: '6px 0 0', fontSize: '14px' }}>
              We will use the information from this form to update your account details and send them to you for confirmation
            </p>
          </div>
          <div style={{ background: '#fff', borderRadius: '6px', padding: '6px 12px', marginLeft: '24px', flexShrink: 0, display: 'flex', alignItems: 'center' }}>
            <img
              src={require('../assets/images/logo.png')}
              alt="Agreya Capital Advisors"
              style={{ height: '52px', width: 'auto', display: 'block' }}
            />
          </div>
        </div>

        <div style={{ padding: '24px' }}>
          {successMessage && (
            <div style={{ background: '#d4edda', border: '1px solid #c3e6cb', borderRadius: '4px', padding: '12px 16px', marginBottom: '20px', color: '#155724', fontSize: '14px' }} role="alert">
              {successMessage}
            </div>
          )}

          {errors.submit && (
            <div style={{ background: '#f8d7da', border: '1px solid #f5c6cb', borderRadius: '4px', padding: '12px 16px', marginBottom: '20px', color: '#721c24', fontSize: '14px' }} role="alert">
              {errors.submit}
            </div>
          )}

          {errors.validation && (
            <div style={{ background: '#f8d7da', border: '1px solid #f5c6cb', borderRadius: '4px', padding: '12px 16px', marginBottom: '20px', color: '#721c24', fontSize: '14px' }} role="alert">
              {errors.validation}
            </div>
          )}

          {/* Tabs */}
          <div className="modification-tabs" style={{ borderBottom: '2px solid #033132', marginBottom: '24px', display: 'flex', gap: '0' }}>
            {HOLDERS.map((holder, index) => {
              const isDisabled = index > 0 && !formData.first_holder_validated;
              return (
                <button
                  key={holder.value}
                  onClick={() => handleTabClick(index)}
                  disabled={isDisabled}
                  style={{
                    padding: '12px 24px',
                    background: currentTabIndex === index ? '#033132' : '#f5f5f5',
                    color: currentTabIndex === index ? '#fff' : '#333',
                    border: 'none',
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    fontWeight: '600',
                    fontSize: '14px',
                    transition: 'all 0.3s ease',
                    opacity: isDisabled ? 0.4 : (currentTabIndex === index || index <= currentTabIndex ? 1 : 0.5)
                  }}
                >
                  {holder.label}
                </button>
              );
            })}
            {/* Nominee Tab */}
            {(() => {
              const isDisabled = !formData.first_holder_validated;
              return (
                <button
                  key="nominee"
                  onClick={() => handleTabClick(3)}
                  disabled={isDisabled}
                  style={{
                    padding: '12px 24px',
                    background: currentTabIndex === 3 ? '#033132' : '#f5f5f5',
                    color: currentTabIndex === 3 ? '#fff' : '#333',
                    border: 'none',
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    fontWeight: '600',
                    fontSize: '14px',
                    transition: 'all 0.3s ease',
                    opacity: isDisabled ? 0.4 : (currentTabIndex === 3 || 3 <= currentTabIndex ? 1 : 0.5)
                  }}
                >
                  Nominee
                </button>
              );
            })()}
            {/* Uploads Tab */}
            {(() => {
              const isDisabled = !formData.first_holder_validated;
              return (
                <button
                  key="uploads"
                  onClick={() => handleTabClick(4)}
                  disabled={isDisabled}
                  style={{
                    padding: '12px 24px',
                    background: currentTabIndex === 4 ? '#033132' : '#f5f5f5',
                    color: currentTabIndex === 4 ? '#fff' : '#333',
                    border: 'none',
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    fontWeight: '600',
                    fontSize: '14px',
                    transition: 'all 0.3s ease',
                    opacity: isDisabled ? 0.4 : (currentTabIndex === 4 || 4 <= currentTabIndex ? 1 : 0.5)
                  }}
                >
                  Uploads
                </button>
              );
            })()}
          </div>

          <form onSubmit={handleSubmit} onKeyPress={handleFormKeyPress} encType="multipart/form-data">
            {/* Render Active Tab Content */}
            {activeTab === 'nominee' ? (
              <div>
                {/* Nominee Sub-tabs */}
                <div className="form-section">
                  <h2>Nominee Details</h2>

                  {(() => {
                    const first = parseFloat(formData.first_nominee_share_percentage) || 0;
                    const second = parseFloat(formData.second_nominee_share_percentage) || 0;
                    const third = parseFloat(formData.third_nominee_share_percentage) || 0;

                    // Only show total if at least one share percentage is entered
                    const hasShareData = (formData.first_nominee_share_percentage && formData.first_nominee_share_percentage !== '') ||
                                        (formData.second_nominee_share_percentage && formData.second_nominee_share_percentage !== '') ||
                                        (formData.third_nominee_share_percentage && formData.third_nominee_share_percentage !== '');

                    if (!hasShareData) return null;

                    const totalShare = (first + second + third).toFixed(2);

                    return (
                      <div style={{
                        background: totalShare === '100.00' ? '#c8e6c9' : '#fff3cd',
                        border: totalShare === '100.00' ? '2px solid #4caf50' : '2px solid #ff9800',
                        borderRadius: '4px',
                        padding: '14px 16px',
                        marginBottom: '20px'
                      }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <span style={{ fontSize: '16px', fontWeight: 'bold', color: totalShare === '100.00' ? '#2e7d32' : '#856404' }}>
                            Total Share Percentage: <span style={{ fontSize: '18px' }}>{totalShare}%</span>
                          </span>
                          <span style={{ fontSize: '13px', color: totalShare === '100.00' ? '#2e7d32' : '#856404' }}>
                            {totalShare === '100.00' ? '✓ Valid' : '⚠ Must equal 100%'}
                          </span>
                        </div>
                      </div>
                    );
                  })()}

                  <div className="modification-tabs" style={{ borderBottom: '2px solid #033132', marginBottom: '24px', display: 'flex', gap: '0' }}>
                    {NOMINEES.map(nominee => (
                      <button
                        key={nominee.value}
                        type="button"
                        onClick={() => setActiveNomineeTab(nominee.value)}
                        style={{
                          padding: '12px 24px',
                          background: activeNomineeTab === nominee.value ? '#033132' : '#f5f5f5',
                          color: activeNomineeTab === nominee.value ? '#fff' : '#333',
                          border: 'none',
                          cursor: 'pointer',
                          fontWeight: '600',
                          fontSize: '14px',
                          transition: 'all 0.3s ease'
                        }}
                      >
                        {nominee.label}
                      </button>
                    ))}
                  </div>

                  {/* Render Active Nominee Tab */}
                  {renderNomineeTab(activeNomineeTab)}
                </div>
              </div>
            ) : activeTab === 'uploads' ? (
              renderUploadsTab()
            ) : (
              renderHolderTab(activeTab)
            )}
          </form>

          {/* Form Actions - Outside Form */}
          <div className="form-actions">
            {currentTabIndex > 0 && (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handlePreviousTab}
                disabled={isSubmitting || (currentTabIndex === 0 && !formData.first_holder_validated)}
              >
                Back
              </button>
            )}
            {currentTabIndex < tabSequence.length - 1 ? (
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleNextTab}
                disabled={isSubmitting || (currentTabIndex === 0 && !formData.first_holder_validated)}
                title={currentTabIndex === 0 && !formData.first_holder_validated ? 'Please verify 1st holder with a valid individual account before continuing' : ''}
              >
                Continue
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  const form = document.querySelector('form');
                  if (form) {
                    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                  }
                }}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Modification Form'}
              </button>
            )}
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => history.goBack()}
              disabled={isSubmitting}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ModificationForm;
